export default "__VITE_ASSET__be3bd74d__"